import React from 'react';
import { Div, DivProps, P } from '@kizi/core-components';
import { IconV2 as Icon } from '@kizi/shared-components';

export interface ExperienceCollectiveCardProps extends DivProps {
  name: string;
  text: string;
  date: string;
}

export const ExperienceCollectiveCard: React.FC<ExperienceCollectiveCardProps> =
  ({ name, text, date, ...rest }) => {
    return (
      <Div
        p={4}
        bg="main.0"
        borderRadius={2}
        maxWidth="293px"
        boxShadow="default"
        display="flex"
        justifyContent="space-between"
        flexDirection="column"
        css={{ boxSizing: 'border-box' }}
        {...rest}
      >
        <Div>
          <Div display="flex" alignItems="center" mb={3}>
            <Icon name="user-empty" size={28} fill="main.1">
              icon
            </Icon>
            <P variant="headlineImportant" ml={1}>
              {name}
            </P>
          </Div>

          <P variant="footnoteRegular">{text}</P>
        </Div>
        <P variant="footnoteRegular" color="second.0" textAlign="end" mt={3}>
          {date}
        </P>
      </Div>
    );
  };
